<template>
  <div class="home">
    <HeaderComponent />

    <div class="content-container">
      <div class="illustration">
        <img src="../assets/image-14.svg" alt="Ilustrație terapie psihologică" />
      </div>

      <h1>PSIHO SUPORT</h1>

      <p class="intro-description">
        Peste 10 ani de experiență în asigurarea intervențiilor psihologice de calitate,
        bazate pe știință și transmise cu profesionalism și empatie clienților nostri.
      </p>

      <div class="features">
        <div class="feature-item">
          <div class="feature-icon">
            <img src="../assets/standard-test-icon-1.svg" alt="Icon teste psihologice" />
          </div>
          <p>
            Folosim teste psihologice standardizate și adaptate specific pentru populația din România,
            asigurând astfel relevanța și acuratețea rezultatelor evaluării.
          </p>
        </div>

        <div class="feature-item">
          <div class="feature-icon">
            <img src="../assets/image-15.svg" alt="Icon stres" />
          </div>
          <p>
            Pentru a sprijini gestionarea stresului și optimizarea stării de bine, integrăm în
            practica noastră tehnologia de vârf, precum sistemul <strong>emWave</strong>, care monitorizează și
            îmbunătățește coerența cardiacă – un indicator esențial al echilibrului emoțional și
            al sănătății mentale.
          </p>
        </div>

        <div class="feature-item">
          <div class="feature-icon">
            <img src="../assets/image-16.svg" alt="Icon universitate" />
          </div>
          <p>
            Cabinetul este partener oficial de practică al Facultății de Psihologie și Științe ale
            Educației, Universitatea Babeș-Bolyai Cluj Napoca
          </p>
        </div>
      </div>

      <section class="services-section">
        <h2>Servicii</h2>

        <ul class="services-list text-left">
          <li><router-link to="servicii/consiliere-individuala">Consiliere psihologică individuală</router-link></li>
          <li><router-link to="servicii/terapie-cuplu">Terapie de cuplu</router-link></li>
          <li><router-link to="servicii/consiliere-copii-adolescenti">Consiliere psihologică pentru copii și adolescenți</router-link></li>
          <li>
            <router-link to="servicii/psihologie-clinica">Psihologie clinică</router-link>
            <ul>
              <li><router-link to="servicii/psihologie-clinica#evaluare-ces">Evaluare psihologică în vederea întocmirii dosarului de CES pentru copii</router-link></li>
              <li><router-link to="servicii/psihologie-clinica#evaluare-handicap-copii">Evaluare clinică în vederea încadrării în grad de handicap pentru copii</router-link></li>
              <li><router-link to="servicii/psihologie-clinica#evaluare-handicap-adulti">Evaluare clinică pentru Comisia de evaluare a persoanelor adulte cu handicap</router-link></li>
            </ul>
          </li>
          <li>
            <router-link to="servicii/psihologie-securitate-nationala">Psihologie aplicată în domeniul securității naționale</router-link>
            <ul>
              <li><router-link to="servicii/psihologie-securitate-nationala">Evaluare psihologică în vederea obținerii/prelungirii avizului de port armă</router-link></li>
            </ul>
          </li>
        </ul>
      </section>
    </div>

    <FooterComponent />
  </div>
</template>

<script>
  import FooterComponent from "../components/FooterComponent.vue";
  import HeaderComponent from "../components/HeaderComponent.vue";

  export default {
    name: 'Home',
    components: {
      HeaderComponent,
      FooterComponent
    }
  };
</script>

<style lang="scss">
  $primary-color: #263f7a;
  $hover-color: #1a2b53;
  $border-color: #333;
  @media screen and (min-width: 0px) {
    .home {
      font-weight: 400;
      color: $border-color;
      font-size: 22px;
      margin-top: 80px;

      .content-container {
        max-width: 1000px;
        margin: 0 auto;
        padding: 20px;
        text-align: center;
      }

      .illustration {
        max-width: 600px;
        margin: 0 auto 30px;
        text-align: center;

        img {
          width: 100%;
          border-radius: 6px;
          display: block;
          margin: 0 auto;
        }
      }

      h1 {
        color: $primary-color;
        font-size: 38px;
        margin-bottom: 20px;
      }

      .intro-description {
        font-weight: bolder;
        font-size: 22px;
        line-height: 1.6;
        max-width: 800px;
        margin: 0 auto 40px;
      }

      .features {
        margin-top: 50px;
        max-width: 900px;
        margin-left: auto;
        margin-right: auto;

        .feature-item {
          margin-bottom: 40px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .feature-icon {
            width: 80px;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: 100%;
              display: block;
              margin: 0 auto;
            }
          }

          p {
            font-size: 22px;
            line-height: 1.6;
            text-align: left;
            max-width: 800px;
          }
        }
      }

      .services-section {
        margin: 60px auto;
        max-width: 900px;
        text-align: left;

        h2 {
          font-size: 36px;
          color: $primary-color;
          margin-bottom: 30px;
          position: relative;
          display: block;
          text-align: center;
        }

        .services-list {
          padding-left: 10px;
          margin-left: 10px;
          text-align: left;

          li {
            list-style-type: disc;
            font-size: 22px;
            margin-bottom: 15px;
            line-height: 1.5;
            font-weight: bold;
            text-align: left;

            a {
              color: $primary-color;
              text-decoration: none;
              transition: color 0.3s ease;
              text-align: left;

              &:hover {
                color: $hover-color;
                text-decoration: underline;
              }
            }

            ul {
              margin-top: 10px;
              padding-left: 30px;
              text-align: left;

              li {
                font-weight: normal;
                list-style-type: none;
                font-size: 22px;
                margin-bottom: 10px;
                text-align: left;

                a {
                  font-weight: normal;
                  text-align: left;
                }
              }
            }
          }
        }
      }

      @media only screen and (min-width: 768px) {
        .features {
          .feature-item {
            flex-direction: column;
            text-align: center;
            align-items: center;

            .feature-icon {
              margin-bottom: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            p {
              text-align: left;
            }
          }
        }

        .services-section {
          .services-list {
            padding-left: 40px;
            margin-left: 30px;
          }
        }
      }
    }
  }
</style>